export default __webpack_public_path__ + "locales/ro/Settings.json?hash=63d0738edf38224aeb8f0805f3b87b46";